// extracted by mini-css-extract-plugin
export default {"container":"rightside_container__JDhWv","trending":"rightside_trending__bRwoN","related":"rightside_related__TxfSp"};